import userAppData from '@/mixins/userAppData';
import { mapGetters } from 'vuex';
import { getClientDeviceType } from '@/utils/deviceType';

export const analytics = {
  mixins: [userAppData],
  data() {
    return {
      ulAnalyticsTimeoutId: null
    };
  },
  computed: {
    ...mapGetters({
      v4token: 'apiToken/v4Token'
    })
  },
  methods: {
    sendAnalyticsUl({
      activity,
      partner_id = null,
      partner_name = null,
      activity_name,
      activity_id,
      delaySeconds = null
    } = {}) {
      if (delaySeconds) {
        this.ulAnalyticsTimeoutId = window.setTimeout(
          () =>
            this.sendAnalyticsUl({
              activity,
              partner_id,
              partner_name,
              activity_name,
              activity_id
            }),
          delaySeconds * 1000
        );
        return;
      }

      this.ulAnalyticsTimeoutId = null;

      this.$http
        .post('/v3/analytics', {
          activity,
          partner_id,
          partner_name,
          activity_name,
          activity_id
        })
        .then(async () => {
          if (
            this.userAppData.length &&
            this.userAppData.findIndex(val => val.name === 'feedbackOpenAt') > -1
          ) {
            const feedbackOpenAt = this.userAppData.find(val => val.name === 'feedbackOpenAt');
            if (feedbackOpenAt.value <= new Date().getTime()) {
              await this.deleteUserAppData('feedbackOpenAt');
            }
          }
        })
        .catch(err => {
          this.handleError({
            error: err,
            showModal: false,
            code: '0x00000054'
          });
        });
    },
    cancelUlAnalyticsTimeout() {
      if (this.ulAnalyticsTimeoutId) {
        window.clearTimeout(this.ulAnalyticsTimeoutId);
        this.ulAnalyticsTimeoutId = null;
      }
    },
    gtmPush(gtmData) {
      this.$gtm.push({
        siteSection: this.currentPath,
        /* eslint-disable camelcase */
        page_language: this.$i18n.locale,
        page_region: this.$domainRegion,
        ...gtmData,
        client_device_type: getClientDeviceType()
        /* eslint-enable */
      });
    },
    gtmSelectLanguage(language) {
      this.gtmPush({
        event: 'select_language',
        'event.detail': language
      });
    },
    async sendEvaluationsAnalyticsStart(formName, internalName) {
      if (!(await this.$store.dispatch('soulodyApi/ensureValidToken'))) {
        return;
      }

      const dateStarted = new Date();
      const tzOffset = -dateStarted.getTimezoneOffset();
      const tzSign = tzOffset >= 0 ? '+' : '-';
      const pad = num => String(Math.floor(Math.abs(num))).padStart(2, '0');
      const tzHours = pad(tzOffset / 60);
      const tzMinutes = pad(tzOffset % 60);

      try {
        const data = await this.$soulodyApi.post('evaluations', {
          profileId: this.$auth.user.profileId,
          formName,
          region: this.$domainRegion.toUpperCase(),
          language: this.$auth.user.language,
          startedAt: dateStarted
            .toISOString()
            .replace(/\.\d{3}Z$/, `${tzSign}${tzHours}:${tzMinutes}`)
        });

        if (data?.uuid) {
          this.$store.commit(
            `staticForms/tally/${internalName}/infoStep/setEvaluationId`,
            data.uuid
          );
        }
      } catch (err) {
        this.handleError({
          error: err,
          showModal: false,
          code: '0x00000061'
        });
      }
    }
  }
};
